export default __webpack_public_path__ + "static/media/remeras_blancas.6cd8d8ef.png";